const zhTw = {
  general: {
    position: '職位',
    updateSuccess: '更新成功！',
    editProfileImg: '個人圖片',
    editCoverImg: '封面圖片',
    register: '註冊',
    login: '登入',
    date: '日期',
    export: '匯出',
    or: '或',
    end: '結束',
    confirmEmail: '確認電子信箱',
    password: '密碼',
    forgetPassword: '忘記密碼',
    changePassword: '更改密碼',
    confirmPassword: '確認密碼',
    knownAs: '暱稱',
    oldPassword: '舊密碼',
    newPassword: '新密碼',
    minLength: '至少需要 {n} 個字元',
    unmatched: '{col}不相符。',
    chooseAnotherAccount: '使用其他帳號登入',
    confirmNewPassword: '確認新密碼',
    required: '必填項目',
    country: '國家',
    new: '新',
    username: '帳號',
    category: '類別'
  },
  editPhoto: '編輯照片',
  deletePhoto: '刪除照片',
  changePhoto: '變更照片',
  savePhoto: '儲存照片',
  livetour: '展間',
  country: {
    JP: '日本',
    KR: '韓國',
    HK: '港澳',
    SG: '新加坡',
    MY: '馬來西亞',
    TH: '泰國',
    VN: '越南',
    ID: '印尼',
    PH: '菲律賓',
    EU: '歐洲',
    NA: '北美',
    NZ: '紐澳',
    TW: '台灣'
  },
  vrlounge: {
    ticketNotOnboardHint: '請於實體展驗票後再進入線上虛擬展',
    cannotChangeAfterSubmit: '送出後將無法更改',
    willReceiveEmail: '您的信箱會收到一封包含著重設密碼連結的email，由WEA2021線上展覽平台系統商iStaging寄出',
    hintLogin: '如果您已經註冊了票號，請點擊“登錄”以電子信箱登錄。',
    lounge: '交流中心',
    networking: '名片夾',
    profile: '個人檔案',
    peopleOnline: '線上使用者',
    totalVisitors: '全部訪客',
    connect: '聯繫',
    waitConfirmed: '等待確認',
    isConfirmed: '已確認',
    confirm: '確認',
    reject: '婉拒',
    confirmReject: '確認拒絕 ?',
    hintReject: '此動作無法復原',
    thinkTwice: '我再想想',
    rejectInvitation: '婉拒邀請',
    connectSuccess: '連結成功',
    block: '封鎖',
    visitor: '訪客',
    exhibitor: '參展商',
    invitationTitle: '個性化邀請訊息',
    invitationPlaceholder: '您好！希望能跟您建立聯繫！（最多不超過 1000個字元）',
    noTicketRecord: '無此票號 請購買票號',
    invalidTicket: '無效的票號',
    enterTicket: '請輸入票號',
    sent: '寄出的',
    received: '收到的',
    connected: '已連結',
    agreeToContinue: '您必須同意條款和條件才能繼續。',
    ticketUsed: '票券已被使用。',
    passwordRule: '密碼必須包含8個字符，至少一個字母和一個數字。',
    cardExchange: '訪客想與你交換名片，請確認是否接受或拒絕交換。',
    loginToAccount: '登入到您的帳號',
    keepLogin: '保持登錄狀態',
    cantLogin: '無法登錄？ 點擊',
    here: '這裡',
    allRole: '全部身份',
    sortNameAtoZ: '姓名（A→Z）',
    sortNameZtoA: '姓名（Z→A）',
    onlineNewToOld: '最後登入時間（新到舊）',
    onlineOldToNew: '最後登入時間（舊到新）',
    exhibitorFirst: '參展商在前',
    visitorFirst: '訪客在前',
    inviteTimeNewToOld: '邀請時間（新到舊）',
    inviteTimeOldToNew: '邀請時間（舊到新）',
    basicInfo: '基本資料',
    contact: '聯繫',
    state: '狀態',
    sentRequest: '等待對方確認邀請',
    haveNotConfirmed: '您尚未確認邀請',
    message: '訊息',
    sendMessageTo: '傳訊息給'
  },
  sort: '排序',
  filter: '篩選',
  test: '測試',
  apply: '套用',
  all: '全部',
  livingroom: '客廳',
  diningroom: '餐廳',
  kitchen: '廚房',
  bedroom: '臥室',
  study: '書房',
  bathroom: '浴室',
  toilet: '廁所',
  garden: '公共設施',
  garage: '車庫/車位',
  outdoors: '建物外觀',
  others: '其他',
  vrTooltip: 'VR模式僅限手機使用。',
  vrInstructions: '請把<strong>手機</strong>放置於<strong>VR眼鏡內</strong>。',
  send: '發送',
  scanQrCode: '掃描QR code，馬上於您的手機上體驗虛擬實境(VR)。',
  logOut: '登出',
  postAsAnonymous: '我想用訪客身份留言。',
  loginGoogle: '以Google+身份登入',
  loginFacebook: '以Facebook帳號登入',
  postComment: '留言',
  selectAction: '請選擇',
  noBuilding: '很抱歉，此物件不存在。',
  browserNoSupport: '<h3>對不起，您的瀏覽器不支持。</h3><p>請下載並安裝最新的瀏覽器版本，如<a href="https://www.google.com/chrome/browser/desktop">Chrome</a>、<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">IE11</a>或<a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>。</p>',
  webGlNoSupport: '<h3>很抱歉，您的瀏覽器或設備不支援 WebGL。請參訪此<a href="https://www.istaging.com/webGLdetect/webGL.html" target="_blank">頁面</a></h3>',
  urlNoSupportIFrameError: '此連結已失效或該頁面不接受外部連結嵌入',
  noPanoramas: '糟糕！此全景圖並不存在',
  buildingNotFound: '<h3>糟糕！您點選的頁面並不存在</h3><p>連結所存在的全景圖可能已被移除</p><a href="https://www.istaging.com/zh-tw/livetour-gallery">前往其他LiveTour</a>',
  weaBuildingNotFound: '<h3>精彩的WEA2021線上展會將於2021年3月10日10點登場!</h3>',
  buildingNotInPropertyRedirect: '<h3>糟糕！此LiveTour已被移除</h3><p>即將為您導向此物件第一個項目......</p>',
  information: '介紹',
  panoSelect: '全景圖',
  floorplan: '平面圖',
  qrCode: 'QR code',
  music: '音樂',
  gyro: 'Gyro',
  vrmode: 'VR 模式',
  fullscreen: '全螢幕',
  like: '讚',
  comment: '留言',
  propertyInfo: '建案介紹',
  buildingInfo: '場景介紹',
  buyNow: '現在購買',
  viewAtHome: 'AR 觀看',
  learnMore: '了解更多',
  contactSupplier: '聯繫供應商',
  memo: '註記',
  location: '地點',
  promotionText: '升級VR實境看屋只要$149起 >',
  promotionLinkText: '立即行動！',
  close: '關閉',
  addComment: '新增留言',
  share: '分享',
  leaveInfoContinue: '請留下您的資訊以觀看LiveTour',
  company: '公司',
  companyName: '公司名稱',
  name: '姓名',
  firstName: '名',
  lastName: '姓',
  email: '電子信箱',
  phone: '電話',
  occupation: '職業',
  emailFormatInvalid: 'email格式不正確。',
  duplicateEmail: '重複的信箱',
  privacyPolicy: '隱私權政策',
  userTerms: '使用者條款',
  visitorLogin: '已經有帳號？',
  visitorAgreement1: '我們十分重視您的資料隱私權。勾選即表示您同意{company}的{termsTag}和{privacyTag}，​同時提供相關管理功能。',
  visitorAgreement2: '勾選即表示您授權{company}致電、發送電子郵件或簡訊提供相關產品和服務信息。您可以通過{email}與我們聯繫來撤銷此授權。',
  visitorAgreement: '我同意<a href="{termsUrl}" target="_blank">服務條款</a>和 <a href="{privacyUrl}" target="_blank"> 帳號私隱政策</a>',
  visitorLeaveDataReason: '請填寫以下資訊，您會於您填寫的 Email 信箱中收到專屬認證連結，點擊後您就能進入觀看 LiveTour 了！',
  visitorAgreePolicy: '我同意該LiveTour 物件擁有者能夠透過email或電話聯絡我',
  visitorEnterAccessKey: '請輸入您email 收到的驗證碼。如果您還未收到, 請到垃圾信件匣檢查',
  accessCode: '驗證碼',
  accessCodeError: '驗證碼錯誤',
  receiveEmailVerification: '請到您的email收取驗證碼',
  verify: '驗證',
  back: '返回',
  welcomeToLiveTour: '歡迎來到 <strong>LiveTour</strong>，進行虛擬體驗',
  resend: '重新寄送',
  invalidAccessCode: '無效的驗證碼',
  resendCodeError: '寄送驗證碼失敗',
  website: '網站',
  cardMore: '更多內容',
  clickNavigate: '點擊前往',
  showMore: '看更多',
  searchTag: '標籤搜尋',
  somethingWrong: '<h3>系統發生未知的問題</h3><a href="https://www.istaging.com/zh-tw/contact">回報問題</a>',
  GuidedTour: '線上帶看',
  ClientWelcome: '歡迎使用',
  ClientFormHint: '點擊”撥打“即表示我同意<a href="https://www.istaging.com/en/terms" target="_blank" class="link-yellow">服務條款</a>、<a class="link-yellow" href="https://www.istaging.com/en/privacy" target="_blank">隱私政策</a> 且專人能透過電話聯繫我',
  ClientFormWelcomeText: '填寫下列資訊後按下撥打，<br>將由專人為您進行<mark class="mark-yellow">線上帶看</mark>，<br>建議您接上耳機麥克風，<br>並在良好的網路環境下進行。',
  ClientWelcomeNamePhoneHint: '請輸入 姓名、電話',
  ClientWelcomeNameHint: '請輸入 姓名',
  ClientWelcomePhoneHint: '請輸入 電話或格式不正確',
  ClientWelcomeLanguage: '語言',
  ClientWelcomeLanguageDesc: '請選擇線上帶看使用的語言。',
  ClientWelcomeLanguageHint: '請選擇 語言',
  FieldRequired: '*必填',
  ClientFormCallNow: '撥打',
  None: '暫無',
  Agent: '專人',
  RememberMe: '記住我',
  TheFieldIsRequired: '此欄位必填',
  IncorrectFormat: '格式有誤',
  YouMustAgreeLicense: '您需要同意以上條款',
  Submit: '送出',
  BuildingNonPublicInfo: '此物件不公開',
  WebRTCNotSupportTitle: '瀏覽器不支援',
  WebRTCNotSupportDesc: '您目前使用的瀏覽器不支援此服務，您可透過按鈕複製網址至 Chrome、Safari 或 Firefox 中開啟',
  WebRTCNotSupportDesciOS: '您目前使用的瀏覽器不支援此服務，您可透過按鈕複製網址至 Safari 開啟',
  WebRTCNotSupportDescAndroid: '您目前使用的瀏覽器不支援此服務，您可透過按鈕複製網址至 Chrome 或 Firefox 開啟',
  WebRTCNotSupportCopyButton: '一鍵複製',
  Copied: '已複製',
  search: '搜尋',
  searchContent: '搜尋內容',
  noResult: '未找到結果',
  searchResult: '搜尋結果',
  relatedResult: '相關推薦',
  scaleUp: '放大',
  scaleDown: '縮小',
  viewIn3D: '以 3D 模式觀看',
  unableJoinMeeting: '無法加入會議',
  invalidMeetingId: '無效的會議編號',
  unableAccessMediaDevice: '瀏覽器無法存取您的攝影機/麥克風，請至瀏覽器媒體權限設定開啟後重整頁面。',
  connectingMeeting: '即將開啟會議',
  meetingNotStartedYet: '會議尚未建立，無法加入',
  joinedMeeting: '已加入會議',
  joiningMeeting: '即將加入會議',
  repeatJoinWarning: '若再次加入，原先連線的頁面將會中斷連線',
  meetingIsOver: '會議已結束',
  startAnotherMeeting: '請至編輯器開啟另一場會議',
  closeMeeting: '結束會議',
  joinMeeting: '加入會議',
  leaveMeeting: '離開會議',
  remainTime: '剩餘時間',
  meetingIsFull: '目前參與會議人數已達上限',
  connectionFail: '連線失敗',
  unableConnectMeeting: '無法連上會議',
  joinMeetingFail: '加入會議失敗',
  aboutEndMeeting: '您即將結束此次會議',
  aboutLeaveMeeting: '您即將離開此次會議',
  endedMeeting: '已結束此次會議',
  meetingRedirect: '將您導回至 LiveTour。',
  leftMeeting: '已離開此次會議',
  waitMeeting: '主持人暫離，待主持人連線後繼續會議。若5分鐘內未連線則將結束會議。',
  disconnectMeeting: '無法連線。請於五分鐘內連線，並刷新頁面以重回會議。',
  copyLink: '複製連結',
  copySuccess: '複製成功',
  confirm: '確定',
  cancel: '取消',
  product: '產品',
  pilot: '導覽',
  pilotStop: '結束導覽',
  pilotTours: '導覽路線',
  pilotPopularTours: '熱門導覽路線',
  pilotInfluencerList: '導覽員清單',
  pilotTourBy: '{influencer} 的所有導覽路線',
  PilotDescription: '內容簡介',
  PilotDetailedInformation: '重點展示內容',
  pilotSwitchTourNotice: '目前正在播放「{pilot1}」，是否要切換至「{pilot2}」？',
  pilotSameTourNotice: '目前正在播放「{pilot1}」，是否要從頭開始？',
  pilotPlayerPopupButtonYes: '確定',
  pilotRecorderStart: '點擊此開始錄製',
  pilotRecorderStop: '點擊此結束錄製',
  pilotRecorderUploading: '上傳中...',
  pilotRecorderUploadFailed: '上傳失敗',
  pilotRecorderPopupTitleNotice: '說明',
  pilotRecorderPopupTitleComplete: '錄製完成',
  pilotRecorderPopupTitleError: '錯誤',
  pilotRecorderPopupTextNotice: '• 錄製時間限制為10分鐘。<br>• 錄製前請先允許系統存取麥克風使用權限。',
  pilotRecorderPopupTextComplete: '導覽章節錄製完成，請回到 VR Editor 觀看與編輯。',
  pilotRecorderPopupTextRelogin: '請重新登入',
  pilotRecorderPopupTextError: '請檢查您瀏覽器中的麥克風權限',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: '10分鐘錄音時間即將結束，請盡快完成您的錄製。',
  pilotTooltipTitle: '提醒您，可以按此處看更多導覽路線。',
  pilotTooltipConfirm: '我知道了！開始吧',
  pilotTooltipCancel: '略過導覽',
  selectPilot: '選擇導覽',
  pilotInfluencer: '導覽員',
  pilotChaptersTitle: '路線章節（選擇以聆聽）',
  pilotReadMoreBtnLabel: '閱讀完整內容',
  pilotSelfBrowsingModeMessageTitle: '進入自行瀏覽模式',
  pilotSelfBrowsingModeMessageContent: '您可隨時點擊開啟按鈕回到導覽模式。',
  pilotReplay: '重播',
  pilotPrevious: '上一個',
  pilotNext: '下一個',
  pilotPause: '暫停',
  pilotPlay: '播放',
  pilotTurnOnSelfBrowsingMode: '關閉導覽模式',
  pilotTurnOffSelfBrowsingMode: '開啟導覽模式',
  conferenceDisconnect: '連線品質不穩。 請檢查您的網路連接。',
  conferenceMute: '靜音',
  conferenceUnmute: '取消靜音',
  conferenceStopVideo: '取消視訊',
  conferenceVideo: '視訊',
  conferenceShare: '共用',
  conferenceChat: '聊天',
  conferenceParticipant: '參加者',
  conferenceAudience: '參加者',
  conferenceMore: '選項',
  conferenceCopyLink: '複製會議鏈結',
  conferenceCameraAndMicrophone: '視訊和麥克風',
  conferenceHost: '主持人',
  conferencePresenter: '主講者',
  conferenceExpel: '驅逐',
  conferenceChangeRole: '將角色變更為',
  conferenceTypeMessage: '在此輸入您的訊息',
  conferenceEveryone: '所有人',
  conferenceLoginError: '登入頻道時出現錯誤，請重新嘗試',
  conferenceJoinError: '進入頻道時出現錯誤，請重新嘗試',
  conferenceLeaveError: '離開頻道時出現錯誤，請重新嘗試',
  conferenceGetMemberCountError: '獲取頻道成員數量時出現錯誤，請重新嘗試',
  conferenceSendMessageError: '發送訊息時出現錯誤，請重新嘗試',
  conferenceSendInfoError: '發佈資訊時出現錯誤，請重新嘗試',
  conferenceGetMemberError: '獲取頻道成員時出現錯誤，請重新嘗試',
  conferenceChangeRoleError: '設置角色時出現錯誤，請重新嘗試',
  conferencePublishError: '發佈影音時出現錯誤，請重新嘗試',
  conferenceCancelPublishError: '取消發佈影音時出現錯誤，請重新嘗試',
  conferenceGetMemberInfoError: '獲取成員訊息時出現錯誤，請重新嘗試',
  conferenceSetMediatError: '調整影音時出現錯誤，請重新嘗試',
  conferenceToLeave: '是否離開會議',
  conferenceToExpel: '是否驅逐%{name}',
  conferenceChangeRoleFail: '角色變更失敗',
  conferenceGetChangeRole: '主持人將你設置為%{role}',
  conferenceGetCameraClosed: '主持人將你的視訊畫面關閉',
  conferenceGetUnmuted: '主持人取消你的靜音',
  conferenceGetMuted: '主持人將你靜音',
  conferenceCopyLinkSuccess: '連結已複製',
  conferenceGetExpeled: '你已被逐出會議',
  conferenceBrowserNotSupported: '您的瀏覽器不支援，請更換到最新版本的Chrome，Safari或Edge',
  conferenceNotStart: '會議尚未開始',
  conferenceEnd: '會議已經結束',
  conferenceTimeup: '會議時間已到',
  conferenceMicrophone: '麥克風',
  conferenceSoundLevel: '聲級',
  conferenceVolume: '音量',
  conferenceCamera: '攝影機',
  conferenceDetectAudioFail: '無法偵測到聲音設備',
  conferenceDetectVideoFail: '無法偵測到視訊設備',
  conferenceShareNotAvailable: '您的瀏覽器不支援此功能。 要共享內容，請使用最新版本的Chrome，Edge或Firefox。',
  conferenceScreenNotAvailable: '有其他主講者正在共享螢幕',
  uploadImage: '上傳圖片',
  productUnavailable: '這個商品已經下架了',
  booking: {
    calendar: '行事曆',
    reserve: '預約',
    dateSelectTitle: '選擇適合您的時段。',
    backToSelect: '選擇另一時間',
    requiredField: '必須填寫',
    timeRange: '時間範圍',
    fieldMessage: '訊息',
    confirm: '確認預約',
    pleaseWait: '請稍候...',
    submitError: '送出請求時發生錯誤：',
    reserveSuccess: '預約成功',
    thanksUser: '謝謝',
    confirmingEmail: '您將很快收到一條確認會議詳細信息的通知。',
    emailEmptyHint: '電子信箱為空'
  },
  favorites: {
    title: '我的最愛',
    add: '加入我的最愛',
    remove: '移除我的最愛',
    category: {
      marker: '產品',
      panorama: '展間',
      company: '公司',
      card: '名片'
    },
    table: {
      image: {
        company: 'Logo',
        marker: '產品圖',
        card: '個人圖片'
      },
      name: {
        company: '公司名稱',
        marker: '產品名稱',
        card: '姓名'
      },
      description: {
        company: '公司敘述',
        marker: '產品敘述'
      },
      type: '類型',
      // price: '價格',
      note: '備註',
      company: '公司',
      occupation: '職位',
      listEmpty: '尚無內容'
    },
    note: {
      empty: '輸入一些備註...（最多 {n} 個字元）',
      saved: '已儲存！'
    },
    pdf: {
      export: '匯出為 PDF',
      exporting: '匯出中...',
      note: '備註：',
      pager: '第 {page} 頁，共 {total} 頁'
    }
  },
  introAssets: {
    enter: '進入'
  },
  whiteList: {
    login: '登入帳號 · 盡情探索',
    error: '* 帳號或密碼錯誤，請再試一次！',
    warnTitle: '認證失敗',
    warnContent: '您所輸入的帳號不存在於授權列表中，請重新輸入或聯繫管理員。'
  },
  instantMessaging: {
    quickQA: '快速問答',
    mediaMessage: '分享了一份檔案',
    locationMessage: '分享了位置資訊',
    startConversation: '在此展區與主辦方開始對話吧！'
  },
  noSearchResult: '查無資料，請更改查詢條件，再進行搜尋',
  tourring: {
    host: '主持人',
    noAnswer: '您的連絡人暫時無法接聽。',
    noPushId: '您的連絡人目前不在線上。',
    busy: '您的連絡人帶看進行中。',
    response: '歡迎利用我們的日曆功能進行預約，感謝您!',
    goToReserve: '前往日曆預約',
    dialing: '撥號中',
    dialingHint: '接通後，將引導至新分頁',
    handupPhoneHint: '您的電話尚未接通，',
    handupPhoneHint2: '請確認是否掛斷？'
  }
}

export default zhTw
